"use strict";

module.exports.SupportedLanguages = ['en', 'de', 'es', 'fr', 'it', 'nl'];